import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './Background.styles.less';
export default function Background({ className, component: Element = 'div', ...others }) {
    const [theme] = useTheme();
    return _jsx(Element, { className: cx(classes.background, classes[theme], className), ...others });
}
